// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
}
.vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE .vendorsTrackerPage_right__OexFj {
  display: flex;
  align-items: center;
  gap: 20px;
}
.vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE .vendorsTrackerPage_right__OexFj .vendorsTrackerPage_date__u1dqG {
  display: flex;
  align-items: center;
  gap: 4px;
}
.vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE .vendorsTrackerPage_right__OexFj .vendorsTrackerPage_date__u1dqG img,
.vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE .vendorsTrackerPage_right__OexFj .vendorsTrackerPage_date__u1dqG svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE .vendorsTrackerPage_right__OexFj .vendorsTrackerPage_date__u1dqG span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.vendorsTrackerPage_inviteModal__G-VEk .vendorsTrackerPage_innerModal__hQtAQ {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
@media (max-width: 450px) {
  .vendorsTrackerPage_inviteModal__G-VEk .vendorsTrackerPage_innerModal__hQtAQ {
    flex-direction: column;
    align-items: center;
  }
}
.vendorsTrackerPage_inviteModal__G-VEk .vendorsTrackerPage_innerModal__hQtAQ .vendorsTrackerPage_innerModalButtonGroup__HAFV3 {
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;
}

@media (max-width: 767px) {
  .vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE {
    padding: 16px;
  }
  .vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE .vendorsTrackerPage_right__OexFj {
    gap: 12px;
  }
  .vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE .vendorsTrackerPage_right__OexFj button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
}
@media (max-width: 425px) {
  .vendorsTrackerPage_pageWrap__kFZyV .vendorsTrackerPage_pageHeader__Pm-LE .vendorsTrackerPage_right__OexFj .vendorsTrackerPage_date__u1dqG span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/vendors-tracker/vendorsTrackerPage.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;;AAUC;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAPF;AASE;EAPD;IAQE,sBAAA;IACA,mBAAA;EAND;AACF;AAQE;EACC,WAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AANH;;AAWA;EAEE;IACC,aAAA;EATD;EAWC;IACC,SAAA;EATF;EAWE;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EATH;AACF;AAeA;EAKK;IACC,aAAA;EAjBJ;AACF","sourcesContent":[".pageWrap {\r\n\t.pageHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.inviteModal {\r\n\t.innerModal {\r\n\t\twidth: 100%;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t\t\r\n\t\t@media (max-width: 450px) {\r\n\t\t\tflex-direction: column;\r\n\t\t\talign-items: center;\r\n\t\t}\r\n\r\n\t\t.innerModalButtonGroup {\r\n\t\t\twidth: 100%;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: end;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 16px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t.right {\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\t.right {\r\n\t\t\t\t.date {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `vendorsTrackerPage_pageWrap__kFZyV`,
	"pageHeader": `vendorsTrackerPage_pageHeader__Pm-LE`,
	"right": `vendorsTrackerPage_right__OexFj`,
	"date": `vendorsTrackerPage_date__u1dqG`,
	"inviteModal": `vendorsTrackerPage_inviteModal__G-VEk`,
	"innerModal": `vendorsTrackerPage_innerModal__hQtAQ`,
	"innerModalButtonGroup": `vendorsTrackerPage_innerModalButtonGroup__HAFV3`
};
export default ___CSS_LOADER_EXPORT___;
